export const CM_PER_PIXEL = 0.03527777777;
export const INCH_PER_PIXEL = 0.01388888888;
export const PLT_UNIT_PER_PIXEL = 400;
export const PIXEL_PER_MM = 2.83464566929;
export const PIXEL_PER_CM = 28.3464566929;
export const PIXEL_PER_INCH = 72;
